module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-modal"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.news.create.title')))]), _vm._v(" "), (_vm.listMessage != null) ? _c('h3', {
    staticClass: "warning-color text-center"
  }, [_vm._v(_vm._s(_vm.listMessage))]) : _vm._e(), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.form,
      "hasLabel": true,
      "translation": "form.news"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-w flex space-between wrap"
  }, [_c('div', {
    staticClass: "flex wrap margin-b-10"
  }, [(!_vm.email || _vm.email.status === 'draft') ? _c('el-button', {
    staticClass: "margin-b-10",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "loading": _vm.form.loading === 'draft'
    },
    on: {
      "click": function($event) {
        return _vm.createEmail(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft')))]) : _vm._e(), _vm._v(" "), (!_vm.email || _vm.email.status != 'done') ? _c('el-button', {
    staticClass: "margin-b-10",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "loading": _vm.form.loading === 'ready'
    },
    on: {
      "click": function($event) {
        return _vm.createEmail(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('el-button', {
    staticClass: "margin-b-10",
    attrs: {
      "loading": _vm.testLoading
    },
    on: {
      "click": _vm.testEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('button.sendTest')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40bb2f6b","hasScoped":false}!./src/app/components/addEmail/addEmail.html
// module id = 2980
// module chunks = 1